import React from 'react'

const Stage = (props) => {
    return (
        <div className="tg23-stage-card">
            <div className="tg23-stage-image-container">
                <img alt={props.stageName} src={props.stageImgLink} className="tg23-stage-hover-image" />
                <div className="tg23-stage-hover-content">
                    <p>{props.stageName}</p>
                </div>
            </div>
            <h2 className="tg23-cardHead">{props.stageName}</h2>
            <p className="tg23-cardDesc">{props.stageDesc}</p>
        </div>
    )
}

export default Stage